import "./App.css";
import Index from "./pages/Index";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import SignUp from "./pages/Auth/Signup";
import Signin from "./pages/Auth/Signin";
import Forgotpass from "./pages/Auth/Forgotpass";
import Checkemail from "./pages/Auth/Checkemail";
import Home from "./pages/User/Home";
import Profile from "./pages/User/Profile";
import UserProfile from "./pages/Auth/UserProfile";
import { useEffect, useState } from "react";
import UserLayout from "./Layaouts/UserLayout";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer, Zoom } from "react-toastify";
import Setnewpass from "./pages/Auth/Setnewpass";
import UserDetailPage from "./pages/User/UserDetailPage";
import MyProfile from "./pages/User/MyProfile";
import PasswordReset from "./pages/Auth/PasswordReset";
import GoogleAuthHandler from "./utils/GoogleAuthHandler";
import 'react-photo-view/dist/react-photo-view.css';
import ContactedProfiles from "./components/FormComponents/ContactedProfiles";
import { getUserPersonalDetails } from "./Redux/Actions/UsersProfileAction";
import Admin from "./pages/User/Admin";
import AdminRoute from "./utils/AdminRoute";
import SuperAdminRoute from "./utils/SuperAdminRoute";
import AdminEditProfile from "./pages/User/AdminEditProfile";
import AdminProfile from "./pages/User/AdminProfile";
import SubAdminManagement from "./pages/User/SubAdminManagement";
import TermsAndConditions from "./pages/TermAndCondition";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  const dispatch = useDispatch();
  const Auth = useSelector((state) => state.Auth);

  const [isLogin, setIsLogin] = useState(!!localStorage.getItem("authToken"));

  const fetchUserPersonalDetails = async () => {
    try {
      await dispatch(getUserPersonalDetails());
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (Auth.isLogin && Auth.token !== "") {
      localStorage.setItem("authToken", Auth.token);
      setIsLogin(true);
    } else {
      const token = localStorage.getItem("authToken");
      setIsLogin(!!token && token !== "" && token !== "null");
    }

    if (localStorage.getItem("authToken")) {
      fetchUserPersonalDetails();
    }

    const handleStorageChange = () => {
      setIsLogin(!!localStorage.getItem("authToken"));
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [Auth.loading, Auth.isLogin, Auth.token, dispatch]);

  return (
    <>
      <BrowserRouter>
        <ToastContainer
          position="top-center"
          autoClose={2000}
          transition={Zoom}
          hideProgressBar
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          draggable
          pauseOnHover
          className="toast-container"
        />

        <Routes>
          {isLogin ? (
            <>
              <Route path="/" element={<UserLayout />}>
                <Route index element={<Home />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/profile/:tabName" element={<Profile />} />
                <Route path="/termsandconditions" element={<TermsAndConditions />} />
                <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                <Route path="/user/:userId" element={<UserDetailPage />} />
                <Route path="/profile/My-profile" element={<MyProfile />} />
                <Route path="/profile/Contacted" element={<ContactedProfiles />} />
                <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
                <Route path="/admin/profile" element={<AdminProfile />} />
                <Route path="/admin/sub-admins" element={<SuperAdminRoute><SubAdminManagement /></SuperAdminRoute>} />
                <Route path="/admin/edit-user/:id" element={<AdminEditProfile />} />
                <Route path="/admin/edit-user/:id/:tabName" element={<AdminEditProfile />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Route>
            </>
          ) : (
            <>
              <Route path="/" element={<Index />} />
              <Route path="/signin" element={<Signin />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/termsandconditions" element={<TermsAndConditions />} />
              <Route path="/privacypolicy" element={<PrivacyPolicy />} />
              <Route path="/personal-details" element={<UserProfile />} />
              <Route path="/forgot-password" element={<Forgotpass />} />
              <Route path="/check-your-email" element={<Checkemail />} />
              <Route path="/reset-password" element={<Setnewpass />} />
              <Route path="/reset-password-success" element={<PasswordReset />} />
              <Route path="/login/callback" element={<GoogleAuthHandler />} />
              {/* Redirect any unknown routes to "/" */}
              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
